<div class="card">
  <div class="card-body">
    <div class="d-flex flex-column">
      <p class="h4 m-0">Tipo de evento</p>
      <p class="p text-secondary">Escolha uma opção para definir se o evento será pago ou gratuito.</p>
    </div>
    <div class="gap-3 d-flex align-items-start justify-content-evenly flex-wrap row">
      <div class="d-flex flex-column align-items-center p-2 gap-2 col-lg-5 col-md-6">
        <app-button
          [styleType]="formGroup.controls.isEventPaid.value ? 'primary' : 'outlined'"
          (btnClick)="handleChangeEventType(true)"
          [disabled]="isEventTypeLocked"
          icon="pi pi-dollar">
          EVENTO PAGO
        </app-button>
        <p
          class="p text-secondary text-center"
          [ngClass]="{ 'fw-bold text-dark': formGroup.controls.isEventPaid.value }">
          Escolha esta opção se desejar vender ingressos para o evento. Note que ingressos gratuitos podem ser
          adicionados posteriormente nos detalhes do evento.
        </p>
      </div>
      <div class="d-flex flex-column align-items-center p-2 gap-2 col-lg-5 col-md-6">
        <app-button
          (btnClick)="handleChangeEventType(false)"
          [disabled]="isEventTypeLocked"
          icon="pi pi-gift"
          [styleType]="!formGroup.controls.isEventPaid.value ? 'primary' : 'outlined'">
          EVENTO GRATUITO
        </app-button>
        <p
          class="p text-secondary text-center"
          [ngClass]="{ 'fw-bold text-dark': !formGroup.controls.isEventPaid.value }">
          Escolha esta opção se todos os ingressos do evento forem gratuitos.
        </p>
      </div>
    </div>

    @if (isEventTypeLocked) {
      <div class="alert alert-warning d-flex align-items-center gap-3 rounded mt-3" role="alert">
        <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
        <p class="m-0"><strong>Atenção:</strong> Não é possível alterar o tipo de evento após o início das vendas.</p>
      </div>
    }

    <hr class="my-4" />

    <div class="d-flex flex-column">
      <p class="h4 m-0">Visibilidade do evento</p>
      <p class="p text-secondary">
        Defina se o evento será público (divulgado na plataforma) ou privado (acesso restrito).
      </p>
    </div>
    <div class="gap-3 d-flex align-items-start justify-content-evenly flex-wrap row">
      <div class="d-flex flex-column align-items-center p-2 gap-2 col-lg-5 col-md-6">
        <app-button
          [styleType]="!isPrivate ? 'primary' : 'outlined'"
          (btnClick)="setVisibility(false)"
          icon="pi pi-globe">
          PÚBLICO
        </app-button>
        <p class="p text-secondary text-center" [ngClass]="{ 'fw-bold text-dark': !isPrivate }">
          O evento aparece na página inicial, em buscas e categorias, e pode ser compartilhado livremente.
        </p>
      </div>
      <div class="d-flex flex-column align-items-center p-2 gap-2 col-lg-5 col-md-6">
        <app-button [styleType]="isPrivate ? 'primary' : 'outlined'" (btnClick)="setVisibility(true)" icon="pi pi-lock">
          PRIVADO
        </app-button>
        <p class="p text-secondary text-center" [ngClass]="{ 'fw-bold text-dark': isPrivate }">
          O evento não aparece na página inicial nem em buscas. O acesso é feito apenas via link
          @if (!isPaid) {
            e, sendo gratuito, exige convite.
          } @else {
            direto.
          }
        </p>
      </div>
    </div>

    <div class="event-rules mt-4">
      <div class="event-rules__header">
        <i class="pi pi-info-circle" aria-hidden="true"></i>
        <div>
          <p class="event-rules__title m-0">{{ currentRule.title }}</p>
          <p class="event-rules__summary m-0">{{ currentRule.summary }}</p>
        </div>
      </div>

      <div class="event-rules__groups">
        <div class="event-rules__group">
          <p class="event-rules__group-title">Divulgação</p>
          <ul class="event-rules__list">
            @for (item of currentRule.promotion; track item) {
              <li>{{ item }}</li>
            }
          </ul>
        </div>

        <div class="event-rules__group">
          <p class="event-rules__group-title">URL e acesso</p>
          <ul class="event-rules__list">
            @for (item of currentRule.access; track item) {
              <li>{{ item }}</li>
            }
          </ul>
        </div>

        <div class="event-rules__group">
          <p class="event-rules__group-title">Ingressos</p>
          <ul class="event-rules__list">
            @for (item of currentRule.tickets; track item) {
              <li>{{ item }}</li>
            }
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
